import styled from "styled-components";
import foto from "../image/FOTO_DE_PERFIL.jpg";

const ProfileContainer = styled.div`
  text-align: center;
  margin-bottom: 2rem;
`;

const Avatar = styled.img`
  width: 120px;
  height: 120px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 1rem;
`;

const Name = styled.h1`
  font-size: 1.8rem;
  font-weight: 700;
  margin: 0;
`;

const Bio = styled.p`
  font-size: 1rem;
  color: #ffffff;
`;

export const ProfileHeader = () => (
  <ProfileContainer>
    <Avatar src={foto} alt="Avatar" />
    <Name>André Luiz | Grupo Powpix</Name>
    <Bio>🥇 Líder em economia para seu negócio.</Bio>
    <Bio>💳 Taxas baixíssimas para CPF ou CNPJ.</Bio>
  </ProfileContainer>
);
